<app-confirmation-modal
    [headline]="'Laufzeit verlängern'"
    [confirmButtonText]="'Laufzeit verlängern'"
    (closeModal)="closeModal()"
    (cancel)="closeModal()"
    (confirm)="onExtendRuntime()">
    <app-runtime-text [item]="item"></app-runtime-text>
</app-confirmation-modal>
